import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import checkIcon from "../assets/svg/CheckIcon.svg";
import DropDownIcon from "../assets/svg/DropDownIcon.svg";
import phoneIcon from "../assets/svg/phoneIcon.svg";
import StateIcon from "../assets/svg/StateIcon.svg";
import DoneIcon from "../assets/svg/DoneIcon.svg";
import HelpIcon from "../assets/svg/HelpIcon.svg";
import { Autocomplete, TextField, Box } from "@mui/material";

function ActivityPopUp({ show, handleClose }) {
  return (
    <>
      <Modal show={show} onHide={handleClose} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Add activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap justify-content-start align-items-center mt-2">
            <div className=" ms-2" style={{ flex: "1 1 30%" }}>
              <h6 className="text-secondary-custom">Call type</h6>
              <Autocomplete
                className="ms-2"
                id="country-select-demo"
                sx={{ width: "100%" }}
                options={[
                  { label: "Service Confirmed", image: checkIcon },
                  { label: "Service Postponement", image: HelpIcon },
                  { label: "Service Executed", image: DoneIcon },
                ]}
                autoHighlight
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Box
                      key={key}
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...optionProps}
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={option.image}
                        alt={option.label}
                      />
                      {option.label}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    className="w-75"
                    {...params}
                    label="please Select"
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className=" ms-2" style={{ flex: "1 1 30%" }}>
              <h6 className="text-secondary-custom">Call Status</h6>
              <Autocomplete
                id="country-select-demo"
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    fontSize: "0.875rem", // تصغير حجم النص في مربع الإدخال
                  },
                  "& .MuiAutocomplete-option": {
                    fontSize: "0.875rem", // تصغير حجم الخط داخل الخيارات
                    paddingLeft: "12px", // تحريك النص قليلاً إلى اليمين
                  },
                }}
                options={[
                  { label: "Reached" },
                  { label: "No Answer" },
                  { label: "Busy " },
                  { label: "Call Back" },
                ]}
                autoHighlight
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Box
                      key={key}
                      component="li"
                      sx={{
                        display: "flex", // استخدام الفليكس لعرض النص بشكل أفقي
                        alignItems: "center",
                        width: "auto", // تأكد أن البوكس يتناسب مع النص
                        marginLeft: "8px", // إضافة المارجن من اليسار
                      }}
                      {...optionProps}
                    >
                      {option.label}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    className="w-75"
                    {...params}
                    label="Please select"
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className=" ms-2 " style={{ flex: "1 1 30%" }}>
              <h6 className="text-secondary-custom">Activity type</h6>
              <Autocomplete
                id="country-select-demo"
                sx={{ width: "100%" }}
                options={[
                  { label: "Service Confirmedfff", image: checkIcon },
                  { label: "Service Postponement", image: HelpIcon },
                  { label: "Service Executed", image: DoneIcon },
                ]}
                autoHighlight
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Box
                      key={key}
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...optionProps}
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={option.image}
                        alt={option.label}
                      />
                      {option.label}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    className="w-75"
                    {...params}
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                      },
                    }}
                  />
                )}
              />
            </div>
          </div>
          <div className="form-floating ms-3 me-3 mt-4">
            <h6 className="text-secondary-custom mt-2 ms-1 me-1">Comments</h6>
            <textarea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style={{ height: "100px" }}
            ></textarea>
          </div>
          <div className="form-floating ms-3 me-3 mt-4">
            <h6 className="text-secondary-custom mt-2 ms-1 me-1">
              Agents Notes
            </h6>
            <textarea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style={{ height: "100px" }}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ActivityPopUp;
